import { RouteObject } from "react-router-dom";
import {
    AuthorizationPage,
    EsiaAuthorizationCallbackHandlerPage,
    SberIdAuthorizationCallbackHandlerPage,
    CpgAuthorizationCallbackHandlerPage,
    PasswordRecoveryPage,
    RegistrationPage,
    SetPasswordPage,
    UkapAuthorizationErrorPage,
    UkepAuthorizationPage,
    VerificationPage,
    ConfirmIdentityPage} from '../pages';

const anonymousRoutes: RouteObject[]  = [
    {   
        path: '/',
        children: [
            { index: true, element: <AuthorizationPage /> },
            {
                path: 'esia/authorization_callback',
                element: <EsiaAuthorizationCallbackHandlerPage />
            },
            {
                path: 'sberid/authorization_callback',
                element: <SberIdAuthorizationCallbackHandlerPage />
            },
            {
                path: 'cpg/authorization_callback',
                element: <CpgAuthorizationCallbackHandlerPage />
            },
            {
                path: 'verification',
                element: <VerificationPage />
            },
            {
                path: 'ukep/authorization',
                element: <UkepAuthorizationPage />
            },
            {
                path: 'ukep/sign-in-error',
                element: <UkapAuthorizationErrorPage />
            },
            {
                path: 'password-recovery',
                element: <PasswordRecoveryPage />
            },
            {
                path: 'registration',
                element: <RegistrationPage />
            },
            {
                path: 'set-password',
                element: <SetPasswordPage />
            },
            {
                path: 'confirm_outdated_info',
                element: <ConfirmIdentityPage />
            }
        ]
    }
];

export default anonymousRoutes;